package com.catbit.opinionpoll.core.sailor.providers

import androidx.compose.runtime.compositionLocalOf
import com.catbit.opinionpoll.core.sailor.overlays.dialog.DialogState

val LocalDialogStateProvider = compositionLocalOf<DialogState> {
    error("DialogState was not provided")
}